import { motion } from 'framer-motion';

export const HowItWorks = () => {
  const steps = [
    {
      num: '01',
      title: 'Choose Your Chip',
      description: 'Select a virtual demo chip value from the selector.'
    },
    {
      num: '02',
      title: 'Choose Your Bet',
      description: 'Select a Roulette number or betting category on the table.'
    },
    {
      num: '03',
      title: 'Spin The Wheel',
      description: 'Click the Spin button and watch the premium wheel turn.'
    },
    {
      num: '04',
      title: 'See The Result',
      description: 'Watch the wheel stop and reveal the winning number.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-charcoal-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-white mb-6"
          >
            How It <span className="text-gold-500">Works</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-gray-400 text-lg leading-relaxed"
          >
            Four simple steps from picking a chip to watching the wheel reveal its number.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="relative p-8 rounded-2xl bg-charcoal-900 border border-gray-800 group hover:border-gold-500/30 transition-colors"
            >
              <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-charcoal-700 to-charcoal-900 mb-4 absolute -top-4 -left-2 opacity-50 group-hover:from-gold-900/50 group-hover:to-charcoal-900 transition-all">
                {step.num}
              </div>
              <div className="relative z-10">
                <span className="text-gold-500 font-bold text-xl mb-4 inline-block">{step.num}</span>
                <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
